import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en/common.json";
import es from "./locales/es/common.json";
import { initGeoLanguageDetection } from "./utils/geoLanguageDetector";

// Migración única: un bug anterior (detector htmlTag con lang="en" fijo)
// guardó "en" en el localStorage de todos los visitantes, también de los
// hispanohablantes. Si el idioma guardado es inglés pero el navegador
// prefiere español, se borra UNA vez para que la detección se repita con
// el orden corregido. Quien elija inglés a propósito después, lo conserva.
try {
  const MIGRATION_FLAG = "i18n_lang_migrated_v1";
  if (!window.localStorage.getItem(MIGRATION_FLAG)) {
    const stored = window.localStorage.getItem("i18nextLng") || "";
    const prefersSpanish = (
      navigator.languages || [navigator.language]
    ).some((l) => (l || "").toLowerCase().startsWith("es"));
    if (stored.toLowerCase().startsWith("en") && prefersSpanish) {
      window.localStorage.removeItem("i18nextLng");
    }
    window.localStorage.setItem(MIGRATION_FLAG, "1");
  }
} catch (e) {
  // sin localStorage: nada que migrar
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: "es",
    supportedLngs: ["en", "es"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    detection: {
      // Sin "htmlTag": index.html lleva lang="en" fijo y forzaba /en para
      // todo el mundo antes de mirar el idioma del navegador.
      order: ["path", "localStorage", "navigator"],
      lookupFromPathIndex: 0,
      caches: ["localStorage"],
      // routesConfig y App.js esperan exactamente "es" | "en"
      convertDetectedLanguage: (lng) => (lng || "").split("-")[0]
    }
  });

initGeoLanguageDetection(i18n);

export default i18n;
